import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ArrayObjectSelectorComponent } from './array-object-selector.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [
    ArrayObjectSelectorComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
  ],
  exports: [
    ArrayObjectSelectorComponent,
  ],
})
export class ArrayObjectSelectorModule { }
